<template>
  <div class="comment__audit-compare-content comment__audit-compare-content_vertical-start">
    <span class="link is-medium-500">
      <!-- Do we need both epic clickable or only second -->
      <router-link
        v-if="beforeEpicNumber"
        class="is-opacity link is-large"
        target="_blank"
        :to="{
          name: 'epic',
          params: {
            epicId: beforeEpicNumber
          }
        }"
      >
        E-{{ beforeEpicNumber }} {{ beforeEpicName }}
      </router-link>
      <span
        v-else
        class="is-opacity"
        >None</span
      >
    </span>
    <icon
      data="@icon/arrow-to.svg"
      :fill="true"
      width="var(--icon-24)"
      height="var(--icon-24)"
      color="var(--monochrome05to04)"
      class="comment__audit-compare-content__arrow"
    />
    <span class="link is-medium-500">
      <router-link
        v-if="afterEpicNumber"
        class="link is-large"
        target="_blank"
        :to="{
          name: 'epic',
          params: {
            epicId: afterEpicNumber
          }
        }"
      >
        E-{{ afterEpicNumber }} {{ afterEpicName }}
      </router-link>
      <span
        v-else
        class="is-opacity"
        >None</span
      >
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import { Comment } from "@/models"

const props = defineProps<{
  comment: Comment
}>()

const beforeEpicName = computed(() => props.comment.before?.epicName ?? "")
const beforeEpicNumber = computed(() => props.comment.before?.epicSequenceNumber ?? null)
const afterEpicName = computed(() => props.comment.after?.epicName ?? "")
const afterEpicNumber = computed(() => props.comment.after?.epicSequenceNumber ?? null)
</script>
